import { gql } from '@apollo/client';

/**
 * GraphQL query for fetching a specific community by ID
 */
export const GET_COMMUNITY = gql`
  query GetCommunity($id: ID!) {
    community(id: $id) {
      id
      name
      communityGroupId
      communityGroup {
        id
        name
      }
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
      logoUrl
      superHeroArtUrl
      optionalMetadata {
        description
        pgRating
        contentGenres
        contentStandardsUrl
        bigId
        contentRating {
          ratingSystem
          ratingValue
          ratingId
          description
          descriptors
          interactiveElements
          ratingUrl
        }
      }
      topics {
        name
        humanModerationAssignedTtlInSeconds
        maxCasesPerModerator
        humanModerationCasesSlaInSeconds
      }
      actions {
        name
        description
        deliveryType
        labels {
          labelId
          severity
        }
        policies
        operatorName
        deliverySettings {
          url
          postPayload
        }
      }
      workflowConfigurations {
        type
        topicActions {
          topicName
          actionNames
        }
        apiSettings {
          maxTps
          monthlyBudget
          costPerAudioHour
          numberOfClipsPerHour
          accessClients {
            providerUrl
            clientIdList
          }
          contentTypeTps {
            text
            image
            audio
          }
        }
      }
      securityGroups {
        admin
        moderator
        user
      }
      userRole
      roles
      moderationStats {
        topicName
        communityId
        openCasesCount
        assignedCasesCount
        inSLACases
        nearSLACases
        outOfSLACases
      }
    }
  }
`;
